import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuApp from '../common/MenuApp';
import routeConfig from '../../common/routeConfig';
import { Link } from 'react-router-dom';
import { Layout, Icon, Row, Col, Tooltip } from 'antd';
import { url } from '../../helper/image';
const { Content, Sider } = Layout;
const MENU_COLLAPSE = 'MENU_COLLAPSE';
/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router. The default one is a two columns layout.
  You should adjust it according to the requirement of your app.
*/
export default class App extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: 'No content.',
  };

  state = {
    collapsed: localStorage.getItem(MENU_COLLAPSE) === 'true' || false,
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  }

  toggle = () => {
    localStorage.setItem(MENU_COLLAPSE, !this.state.collapsed);

    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    let slider = () => { };
    if (this.props.is.admin) {
      slider = () =>
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
        >
          <Row type="flex" justify="center">>
              <Col className="logo_back" span={14}>
              <Link to="/">
                <img src={url("logo/logo-ynov-bx.svg")} ></img>
              </Link>
            </Col>
            <Tooltip placement="right" title={this.state.collapsed ? 'Agrandir le menu' : 'Réduire le menu'}>
              <Col
                onClick={this.toggle}
                span={24} style={{ textAlign: 'center', color: '#fff', padding: '10px', fontSize: '15px', backgroundColor:'#002140' }}>
                <Icon
                  className="trigger"
                  type={this.state.collapsed ? 'caret-right' : 'caret-left'}
                />
              </Col>
            </Tooltip>
          </Row>
          <MenuApp theme="dark" defaultSelectedKeys={['1']} mode="inline" routes={routeConfig} />
        </Sider>
    }

    return (
      <div>
        <Layout style={{ minHeight: '100vh' }}>
          {slider()}
          <Layout>
            <Content className="page-container">
              {this.props.children}
            </Content>
          </Layout>
        </Layout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Layout.js